import { render, staticRenderFns } from "./FiltersSubCategories.vue?vue&type=template&id=71782598&"
import script from "./FiltersSubCategories.vue?vue&type=script&lang=js&"
export * from "./FiltersSubCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/toastgroup.no/toastgroup.no/wp-content/themes/toastgroup/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71782598')) {
      api.createRecord('71782598', component.options)
    } else {
      api.reload('71782598', component.options)
    }
    module.hot.accept("./FiltersSubCategories.vue?vue&type=template&id=71782598&", function () {
      api.rerender('71782598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/front/js/compontents/filters/FiltersSubCategories.vue"
export default component.exports